var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomReportsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.833 15.833H4.167V4.167h5V2.5h-5C3.25 2.5 2.5 3.25 2.5 4.167v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667v-5h-1.667zm-3.333-5v3.334h1.667v-3.334zm-3.333 3.334h1.666V7.5H9.167zm-1.667 0v-5H5.833v5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 5a1.666 1.666 0 1 0 0-3.332A1.666 1.666 0 0 0 15 5m0 .834c-1.113 0-3.333.558-3.333 1.666v.834h6.666V7.5c0-1.108-2.22-1.666-3.333-1.666"
})));
export { SvgCustomReportsIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/customReportsIcon.52ddf5b5.svg";